import { Component } from "react";
import { Button, Table } from "react-bootstrap";
import BirthdayIcon from "../../assets/black/birthday.png";
import PhoneIcon from "../../assets/phone.png";
import HomeIcon from "../../assets/home.png";
import WFFIcon from "../../assets/location_man.png";
import LocationIcon from "../../assets/location.png";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import VisibilitySensor from "react-visibility-sensor";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { IoCloseOutline } from "react-icons/io5";
import Attachment from "../../components/attachment/Attachment";
import TimeFormatter from "../../utility/TimeFormatter";
import GetImage from "../../components/getimage/Getimage";
import GetHrsTime from "../../utility/GetHrsTime";
import { GetDayDifference } from "../../utility/DaysDiff";
import Tint from "../../utility/ImageTint/Tint";
import Hexapi from "../../utility/HexAPI/Hexapi";
import Inputbox from "../../components/formcontrols/normal/InputBox";
import { convertTimezoneDayMonth } from "../../utility/convertTimezoneDayMonth";
import Loader from "../../components/loader/Loader";


export default class ApprovalTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      userid: this.props.userid,
      headers: {
        Overtime: ["", "Employee", "Check In", "Check Out", "Shift Hrs"],
        Subordinate: ["", "Employee", "Mobile Number", "Date Of Birth"],
        TagIdUsers: ["", "Employee", "Date Of Birth"],
        PendingLeave: [
          "",
          "Employee",
          "Leave Type",
          "Time",
          "Reason",
          "Substitute",
          "Duration",
        ],
        ApprovedLeave: [
            "Approval Remarks",
            "Employee",
            "Leave Type",
            "Time",
            "Reason",
            "Substitute",
            "Duration",
          ],
        RejectedLeave: [
            "Rejection Remarks",
            "Employee",
            "Leave Type",
            "Time",
            "Reason",
            "Substitute",
            "Duration",
          ],
        GatePass: ["", "Employee"],
        Expense: [
          "",
          "Employee",
          "Description",
          "Expence on",
          "Expense Type",
          "Requested Amount",
        ],
        Fieldpass: [
          "",
          "Employee",
          "Date",
          "Pass type",
          "Stage",
          "Reason",
          "Remarks",
        ],
      },
      isModalLoading: false,
      showModal: false,
      actionRecid: null,
      actionType: null,
      errors: {
        approvedExpense: "",
        remarks: "",
      },
      approvalempname: "",
      acceptrejectstate: "",
      isViewModalOpen: false,
      id: "",
      isAllowDownload: true,
      setBase64: "",
      setImage: "",
      isQueryHitComplete: false,
      attachmentid: null,
      watermarkArr: "",
      approvalempname: null,
      getwatermarkData: "",
    };
    this.getHeader = this.getHeader.bind(this);
    this.setRowsFromHeaders = this.setRowsFromHeaders.bind(this);
    this.setFullDateString = this.setFullDateString.bind(this);
    this.getLeaveActionDescription = this.getLeaveActionDescription.bind(this);
    this.getDOB = this.getDOB.bind(this);
    this.getTAgIDActionDescription = this.getTAgIDActionDescription.bind(this);
    this.getSubordinateDescription = this.getSubordinateDescription.bind(this);
    this.getOvertimeDescription = this.getOvertimeDescription.bind(this);
    this.getTime = this.getTime.bind(this);
    this.getTimeOnly = this.getTimeOnly.bind(this);
    this.ActionSubmit = this.ActionSubmit.bind(this);
    this.handleRemarksChange = this.handleRemarksChange.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalYes = this.handleModalYes.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.getUTCFromTimezone = this.getUTCFromTimezone.bind(this);
    this.getTimezoneString = this.getTimezoneString.bind(this);
    this.AcceptReject=this.AcceptReject.bind(this)
  }

  AcceptReject(data){
console.log(data,"datatatahgvdjhsjdhdbj")
    if(data.approvalstage == "0") return null
if (data.approvalstage == "1") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } 
    } else {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
          </div>
        );
      } 
    }
  }
  getTimezoneString() {
    const offset = new Date().getTimezoneOffset();
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
    const sign = offset <= 0 ? "+" : "-";
    return `UTC ${sign}${hours}:${minutes}`;
  }

  getUTCFromTimezone(timezone) {
    const utcMatch = timezone.match(/UTC\s?([-+]\d+):(\d+)/);
    return utcMatch[0];
  }

  componentDidMount() {
    console.log(this.props.tableData);
    let obj = {
      query: `[dbo].[HRApp_Droid_Proc_User_GetAttachmentRight]@UserID='{0}'`,
      queryArr: [`${this.props.userid}`],
    };

    Hexapi(obj).then((resp) => {
      // console.log(resp);
      this.setState({ watermarkArr: resp[""][0].disablewatermark });
      // console.log(resp[""][0].allowdownload);

      if (resp[""][0].allowdownload === 1) {
        this.setState({
          isAllowDownload: true,
        });
      } else {
        this.setState({
          isAllowDownload: false,
        });
      }
      setTimeout(() => {
        // console.log(this.state.isAllowDownload);
        this.setState({
          isQueryHitComplete: true,
        });
      }, 300);
    });
    // console.log(this.props.tableData[0].approvalempname)
  }
  ActionSubmit(recid, Action) {
    // console.log(Action, "fjdhudghiuf-----");
    this.setState({ acceptrejectstate: Action }, () => {
      this.setState({
        showModal: true,
        actionRecid: recid,
        actionType: Action,
      });
    });
  }
  handleRemarksChange(e) {
    this.setState({ remarks: e.target.value });
  }

  handleModalClose() {
    this.setState({ showModal: false, remarks: "" });
  }
  handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (
      this.props.approvaltype === 6 &&
      this.state.acceptrejectstate === "1" &&
      !this.state.approvedExpense
    ) {
      formIsValid = false;
    
      Swal.fire({
        confirmButtonColor: "#28b6f6",
        text: "Approved Amount is required",
      });
      // errors["approvedExpense"] = "Approved Amount is required";
    }

    if (!this.state.remarks) {
      formIsValid = false;
      Swal.fire({
        confirmButtonColor: "#28b6f6",
        text: "Remarks are required",
      });
      // errors["remarks"] = "Remarks are required";
    }

    this.setState({ errors: errors });
    return formIsValid;
  };
  handleModalYes() {
    // console.log(this.state.acceptrejectstate);
    const { actionRecid, actionType, remarks, approvedExpense } = this.state;
    // console.log(approvedExpense);
    if (this.handleValidation()) {
      if (
        this.props.approvaltype == "6" &&
        this.state.acceptrejectstate == "1"
      ) {
        let obj = {
          query: `HRApp_Droid_Proc_User_Approvals_Action_SubmitV2 @Recid='{0}',@UserID='{1}',@ApprovalType='{2}',@Action='{3}', @Remarks='{4}',@approvedamount='{5}'`,
          queryArr: [
            `${actionRecid}`,
            `${this.props.userid}`,
            `${this.props.approvaltype}`,
            `${actionType}`,
            `${remarks}`,
            `${approvedExpense}`,
          ],
        };
        this.setState({ isModalLoading: true, showModal: false });
        Hexapi(obj)
          .then((resp) => {
            console.log(resp,"hdgfjzdukilolsk");
            this.setState({ isModalLoading: false });
            Swal.fire({
              confirmButtonColor: "#28b6f6",
              text: resp.approvallist[0].msg,
            }).then(() => {
              if (resp.approvallist[0].command == 1) {
                this.props.LoadMore("-1");
              }
            });
          })
          .catch((err) => console.error(err));
      } else {
        let obj = {
          query: `HRApp_Droid_Proc_User_Approvals_Action_SubmitV2 @Recid='{0}',@UserID='{1}',@ApprovalType='{2}',@Action='{3}', @Remarks='{4}'`,
          queryArr: [
            `${actionRecid}`,
            `${this.props.userid}`,
            `${this.props.approvaltype}`,
            `${actionType}`,
            `${remarks}`,
          ],
        };
        this.setState({ isModalLoading: true, showModal: false });
        Hexapi(obj)
          .then((resp) => {
            console.log(resp,"reahgsjdfhsd");
            this.setState({ isModalLoading: false });
            Swal.fire({
              confirmButtonColor: "#28b6f6",
              text: resp.approvallist[0].msg,
            }).then(() => {
              if (resp.approvallist[0].command == 1) {
                this.props.LoadMore("-1");
              }
            });
          })
          .catch((err) => console.error(err));
      }
    }
  }
  getDOB(logtime) {
    if (logtime != null && logtime != "" && logtime != undefined) {
      if (logtime.date != undefined) {
        let dateObj = TimeFormatter(logtime.date,3);
        // console.log(dateObj)
        let str = `${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} ${dateObj.userSplitedDate[0]}`;
        return str;
      } else {
        let dateObj = TimeFormatter(logtime,3);
        // console.log(dateObj)
        let str = `${dateObj.userSplitedDate[2]} ${dateObj.shiftFullMonth} ${dateObj.userSplitedDate[0]}`;
        return str;
      }
    }
  }
  getTimeOnly(logtime) {
    if (logtime != null && logtime != "" && logtime != undefined) {
      if (logtime.date != undefined) {
        let dateObj = TimeFormatter(logtime.date,3);
        let str = `${dateObj.ShiftTime}`;
        return str;
      } else {
        let dateObj = TimeFormatter(logtime,3);
        let str = `${dateObj.ShiftTime}`;
        return str;
      }
    } else {
      return "--";
    }
  }
  getTime(data, type) {
    if (type == "checkin") {
      return (
        <>
          <div className="Overtime_time">
            <div className="timeRow">
              <div className="time" style={{ color: "var(--Work)" }}>
                <span>
                  <ArrowDownwardIcon />
                </span>
                {this.getTimeOnly(data.opentime)}
              </div>
            </div>
            {data.checkinlocationname != "-1" &&
            data.checkinlocationname != null &&
            data.checkinlocationname != undefined ? (
              <div className="locationRow" style={{ color: "#696969" }}>
                <div className="icon">
                  <img
                    src={LocationIcon}
                    alt=""
                    style={{ filter: Tint("#696969") }}
                  />
                </div>
                <span>
                  <a
                    href={`https://maps.google.com/?q=${data.checkinlocationname}&ll=${data.checkinlocationname}F&z=20`}
                    target="_blank"
                  >
                    {data.checkinlocationname}
                  </a>
                </span>
              </div>
            ) : data.checkinlocation != "-1" && data.checkinlocation != null ? (
              <div className="locationRow" style={{ color: "#696969" }}>
                <div className="icon">
                  <img
                    src={LocationIcon}
                    alt=""
                    style={{ filter: Tint("#696969") }}
                  />
                </div>
                <span>
                  <a
                    href={`https://maps.google.com/?q=${data.checkinlocation}&ll=${data.checkinlocation}F&z=20`}
                    target="_blank"
                  >
                    {data.checkinlocation}
                  </a>
                </span>
              </div>
            ) : null}
          </div>
        </>
      );
    } else if (type == "checkout") {
      return (
        <div className="Overtime_time">
          <div className="timeRow">
            <div
              className="time"
              style={{ color: "#ff0000", position: "relative" }}
            >
              <span>
                <ArrowDownwardIcon />
              </span>
              {this.getTimeOnly(data.checkouttime)}
              {data.shiftstatus != "1"
                ? GetDayDifference(data.opentime, data.checkouttime)
                : ""}
            </div>
          </div>
          {data.checkoutlocationname != "-1" &&
          data.checkoutlocationname != null &&
          data.checkoutlocationname != undefined ? (
            <div className="locationRow" style={{ color: "#696969" }}>
              <div className="icon">
                <img
                  src={LocationIcon}
                  alt=""
                  style={{ filter: Tint("#696969") }}
                />
              </div>
              <span>
                <a
                  href={`https://maps.google.com/?q=${data.checkoutlocationname}&ll=${data.checkoutlocationname}F&z=20`}
                  target="_blank"
                >
                  {data.checkoutlocationname}
                </a>
              </span>
            </div>
          ) : data.checkoutlocation != "-1" && data.checkoutlocation != null ? (
            <div className="locationRow" style={{ color: "#696969" }}>
              <div className="icon">
                <img
                  src={LocationIcon}
                  alt=""
                  style={{ filter: Tint("#696969") }}
                />
              </div>
              <span>
                <a
                  href={`https://maps.google.com/?q=${data.checkoutlocation}&ll=${data.checkoutlocation}F&z=20`}
                  target="_blank"
                >
                  {data.checkoutlocation}
                </a>
              </span>
            </div>
          ) : null}
        </div>
      );
    }
  }
  getHeader(props) {
    if (props.approvaltype == "4") {
        if(props.tableData[0].approvalstage == 0){
            return this.state.headers.PendingLeave.map((head) => {
                return (
                  <th key={head} style={{ textAlign: "left" , background: "var(--Primary)", color: "white", }}>
                    {head}
                  </th>
                );
              });
        }else if(props.tableData[0].approvalstage == 1){
            return this.state.headers.ApprovedLeave.map((head) => {
                return (
                  <th key={head} style={{ textAlign: "left" , background: "var(--Primary)", color: "white", }}>
                    {head}
                  </th>
                );
              });
        }else if(props.tableData[0].approvalstage == 2){
            return this.state.headers.RejectedLeave.map((head) => {
                return (
                  <th key={head} style={{ textAlign: "left", background: "var(--Primary)", color: "white", }}>
                    {head}
                  </th>
                );
              });
        }
      
    } else if (props.approvaltype == "3") {
      return this.state.headers.TagIdUsers.map((head) => {
        return (
          <th key={head} style={{ textAlign: "left", background: "var(--Primary)", color: "white", }}>
            {head}
          </th>
        );
      });
    } else if (props.approvaltype == "2") {
      return this.state.headers.Subordinate.map((head) => {
        return (
          <th key={head} style={{ textAlign: "left" , background: "var(--Primary)", color: "white",}}>
            {head}
          </th>
        );
      });
    } else if (props.approvaltype == "1") {
      return this.state.headers.Overtime.map((head) => {
        return (
          <th key={head} style={{ textAlign: "left", background: "var(--Primary)", color: "white", }}>
            {head}
          </th>
        );
      });
    } else if (props.approvaltype == "5") {
      let fieldpassHeaders = [...this.state.headers.GatePass];
      if (props.tableData[0] && props.tableData[0].approvalstage == 1) {
        fieldpassHeaders[2] = "Exit time";
        fieldpassHeaders[3] = "Entry time";
      }
      if (props.tableData[0] && props.tableData[0].approvalstage == 1) {
        fieldpassHeaders[5] = "Actual Duration";
        // fieldpassHeaders[8] = 'Approver Remarks';
      }
      // if(props.tableData[0] && props.tableData[0].approvalstage == 2){
      //     fieldpassHeaders[8] = 'Rejected Remarks';
      // }
      fieldpassHeaders[4] = "Assigned duration";
      fieldpassHeaders[6] = "Reason";
      fieldpassHeaders[7] = "Remarks";
      return fieldpassHeaders.map((head) => {
        return (
          <th key={head} style={{ textAlign: "left", background: "var(--Primary)", color: "white", }}>
            {head}
          </th>
        );
      });
    } else if (props.approvaltype == "6") {
      let fieldpassHeaders = [...this.state.headers.Expense];
      if (props.tableData[0] && props.tableData[0].approvalstage == "1") {
        fieldpassHeaders[8] = "Approval Remarks";
        fieldpassHeaders[6] = "Approved Amount";
      } else if (
        props.tableData[0] &&
        props.tableData[0].approvalstage == "2"
      ) {
        fieldpassHeaders[8] = "Rejection Remarks";
      }
      fieldpassHeaders[7] = "Remarks";
      fieldpassHeaders[9] = "Attachment";
      return fieldpassHeaders.map((head) => {
        return (
          <th key={head} style={{ textAlign: "center", background: "var(--Primary)", color: "white", }}>
            {head}
          </th>
        );
      });
    } else if (props.approvaltype == "7") {
      let fieldpassHeaders = [...this.state.headers.Fieldpass];
      if (props.tableData[0] && props.tableData[0].approvalstage == "1") {
        fieldpassHeaders[8] = "Approval Remarks";
      } else if (
        props.tableData[0] &&
        props.tableData[0].approvalstage == "2"
      ) {
        fieldpassHeaders[8] = "Rejection Remarks";
      }
      return fieldpassHeaders.map((head) => {
        return (
          <th key={head} style={{ textAlign: "center", background: "var(--Primary)", color: "white",}}>
            {head}
          </th>
        );
      });
    }
  }
  convertMinutesToTime(minutes) {
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;

    hours = hours < 10 ? "0" + hours : hours;
    mins = mins < 10 ? "0" + mins : mins;

    return `${hours}:${mins}`;
  }


  getTimezoneString(){
    const offset = new Date().getTimezoneOffset();
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
    const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
    const sign = offset <= 0 ? "+" : "-";
    return `UTC ${sign}${hours}:${minutes}`;
}

setFullDateString(logtime) {
    if (logtime != null && logtime != "" && logtime != undefined) {
        if (logtime.date != undefined) {
          
            let dateObj = TimeFormatter(logtime.date)
            // console.log(dateObj)
            let str = `${dateObj.ShiftTime}, ${dateObj.userSplitedDate[2]} ${dateObj.ShiftMonth}'${dateObj.userSplitedDate[0].slice(-2)}`
            return str
        } else {
            let dateObj = TimeFormatter(logtime,3)
            // console.log(dateObj)
            let str = `${dateObj.ShiftTime}, ${dateObj.userSplitedDate[2]} ${dateObj.ShiftMonth}'${dateObj.userSplitedDate[0].slice(-2)}`
            return str
        }
    }
}

  getLeaveActionRemarks(data, approvaltype, RequestCategory) {
    // console.log(data)
    if (data.approvalstage == "1") {
        return <span>{data.remarks}</span>
    }else if(data.approvalstage == "2"){
        return <span>{data.remarks}</span>
    }
  }
  getLeaveActionDescription(data, approvaltype, RequestCategory) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
     
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = (
          <div>
             <span>
            Accepted By{" "}
            {data.approvalempid == this.state.userid
              ? "You"
              : data.approvalempname}{" "}
            {data.approvedon != undefined
              ? " on " +
                convertTimezoneDayMonth(data.approvedon.date, data.timezone)
              : null}
            
            {this.getUTCFromTimezone(data.timezone) !==
              this.getTimezoneString() && (
              <div style={{ fontStyle: "italic",   fontSize: "10px" }}>
                {data.timezone}
              </div>
            )}
          </span>
          </div>
         
        );
      
    } else {
      
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = (
          <div>
 <span>
            Rejected By{" "}
            {data.approvalempid == this.state.userid
              ? "You"
              : data.approvalempname}{" "}
            on {convertTimezoneDayMonth(data.approvedon.date, data.timezone)}
            {this.getUTCFromTimezone(data.timezone) !==
              this.getTimezoneString() && (
              <div style={{ fontStyle: "italic",   fontSize: "10px" }}>
                {data.timezone}
              </div>
            )}
          </span>
          
          </div>
         


        );
      
    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
        <div className="">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
            key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          </div>
          <div style={{marginLeft: "10px" }}>
            <div>
            {this.getLeaveActionRemarks(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
            </div>
          <div style={{ color: color, }}>
            {setApprovalTxt}
          </div>
          </div>
          <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
          </div>
        
      );
    }
  }

  getTAgIDActionDescription(data, approvaltype, RequestCategory) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
    
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = `Accepted By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } ${
          data.approvedon != undefined
            ? " on " + this.setFullDateString(data.approvedon)
            : ""
        }`;
    } else {
      
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = `Rejected By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } ${   data.approvedon != undefined ? "on" +this.setFullDateString(data.approvedon) :""} `;

    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
            key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
  <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
          </div>
        
           <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  getSubordinateDescription(data) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
     
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = `Accepted By ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      
    } else {
     
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = `Rejected By ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      
    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
               key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
  <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
          </div>
        

           <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  getOvertimeDescription(data) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
      
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = `Accepted By ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      
    } else {
      
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = `Rejected By ${
          data.approvalempid == this.props.userid ? "You" : data.approvalempname
        }`;
      
    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
               key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
   <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
          </div>
       

           <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  getGatePassDescription(data, approvaltype, RequestCategory) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
     
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = (
          <span>
            Accepted By{" "}
            {data.approvalempid == this.state.userid
              ? "You"
              : data.approvalempname}{" "}
            {data.approvedon != undefined
              ? " on " +
                convertTimezoneDayMonth(data.approvedon.date, data.timezone)
              : ""}
            <br />
            {this.getUTCFromTimezone(data.timezone) !==
              this.getTimezoneString() && (
              <span style={{ fontStyle: "italic",   fontSize: "10px" }}>
                {data.timezone}
              </span>
            )}
          </span>
        );
      
    } else {
      
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = (
          <span>
            Rejected By{" "}
            {data.approvalempid == this.state.userid
              ? "You"
              : data.approvalempname}{" "}
            on {convertTimezoneDayMonth(data.approvedon.date, data.timezone)}
            <br />
            {this.getUTCFromTimezone(data.timezone) !==
              this.getTimezoneString() && (
              <span style={{ fontStyle: "italic",   fontSize: "10px" }}>
                {data.timezone}
              </span>
            )}
          </span>
        );
      
    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_statusnew">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
               key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
             <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
            </div>
          <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  getExpenseDescription(data, approvaltype, RequestCategory) {
    let showapprovedImg = false;
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
    
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = `Accepted By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } ${
          data.approvedon != undefined
            ? " on " + this.setFullDateString(data.approvedon)
            : ""
        }`;
      
    } else {
     
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = `Rejected By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } on ${this.setFullDateString(data.approvedon)}`;
      
    }

    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
               key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
 <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
          </div>
          <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  getFieldpassDescription(data, approvaltype, RequestCategory) {
 
    let approverImgId = "";
    let color = "";
    let setApprovalTxt = "";
    let acceptImg = "";
    let rejectImg = "";
   let showapprovedImg = false;
    let isShowBtns = true;
    if (data.approvalstage == "0") {
      if (data.actionmode == "1") {
        return (
          <div className="LeaveActionButtons">
            <span
              style={{ background: "#4CAF50" }}
              onClick={() => this.ActionSubmit(data.recid, "1")}
            >
              Accept
            </span>
            <span
              style={{ background: "#ff0000" }}
              onClick={() => this.ActionSubmit(data.recid, "2")}
            >
              Reject
            </span>
          </div>
        );
      } else {
        isShowBtns = false;
        showapprovedImg = true;
        approverImgId = data.approvalempid;
        color = "black";
        setApprovalTxt = `Pending With ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        }`;
      }
    } else if (data.approvalstage == "1") {
    
        isShowBtns = false;
        showapprovedImg = true;
        acceptImg = true;
        color = "var(--Work)";
        setApprovalTxt = `Accepted By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } ${
          data.approvedon != undefined
            ? " on " + this.setFullDateString(data.approvedon)
            : ""
        }<div>
        getshgdhj
        </div>`;
      
    } else {
        isShowBtns = false;
        showapprovedImg = true;
        rejectImg = true;
        color = "var(--Overtime)";
        setApprovalTxt = `Rejected By ${
          data.approvalempid == this.state.userid ? "You" : data.approvalempname
        } on ${this.setFullDateString(data.approvedon)}`;
    }
    if (!isShowBtns) {
      return (
        <div className="leave_table_status">
          {acceptImg ? (
            <IconButton style={{ background: "var(--Work)" }}>
              <CheckIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : rejectImg ? (
            <IconButton style={{ background: "var(--Overtime)" }}>
              <CloseIcon style={{ color: "#fff", fontSize: "16px" }} />
            </IconButton>
          ) : approverImgId ? (
            <GetImage
               key={approverImgId}
              top={true}
              width={"32px"}
              height={"32px"}
              imgID={approverImgId}
              getPhotoUrl={this.props.getPhotoUrl}
            />
          ) : null}
          <div>
     <span style={{ color: color, marginLeft: "10px" }}>
            {setApprovalTxt}
          </span>
          </div>
      <div>
            {
              this.AcceptReject(data)
            }
          
          </div>
        </div>
      );
    }
  }
  downloadFile = () => {
    
const obj={
  query:`HrApp_Droid_Proc_User_GetAttachment @AttachmentID='{0}',@UserID ='{1}'`,
  queryArr:[`${this.state.attachmentid}`,`${this.props.userid}`]
}
    Hexapi(obj)
      .then((resp) => {
        var base64Type = "";
        var extension = resp[""][0]["extension"];
        switch (extension) {
          case ".zip":
            base64Type = "application/x-zip-compressed";
            break;
          case ".txt":
            base64Type = "text/plain";
            break;
          case ".doc":
            base64Type = "application/msword";
            break;
          case ".xls":
            base64Type = "application/vnd.ms-excel";
            break;
          case ".ppt":
            base64Type = "application/vnd.ms-powerpoint";
            break;
          case ".png":
            base64Type = "image/png";
            break;
          case ".jpg":
            base64Type = "image/jpg";
            break;
          case ".pdf":
            base64Type = "application/pdf";
            break;
          case ".jpeg":
            base64Type = "image/jpeg";
            break;
          case ".mpeg":
            base64Type = "audio/mpeg";
            break;
          default:
            break;
        }
        const imageData = `data:${base64Type};base64,${resp[""][0].attachment}`;
        const fileUrl = imageData;
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;
        downloadLink.setAttribute("download", this.props.fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch((err) => console.error("Document Fetching Error: ", err));
  };

  viewAttachment(attachmentid, approvalempname) {
    // console.log("hahaha");
    // console.log("Working...");
    // console.log(attachmentid);
    // console.log(approvalempname);
    this.setState({
      isViewModalOpen: true,
      attachmentid: attachmentid,
      approvalempname: approvalempname,
    });
  }

  setRowsFromHeaders(data, approvaltype) {
    // console.log(approvaltype);
    if (approvaltype == "4") {
      return (
        <>
          <td>
            {this.getLeaveActionDescription(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
          </td>
          <td>
            <div
              className="LeaveUserDescription"
              style={{ alignContent: "center", fontSize: "14px" }}
            >
              
              <div className="image">
                <GetImage
                   key={data.empid}
                  top={true}
                  width={"32px"}
                  height={"32px"}
                  imgID={data.empid}
                  getPhotoUrl={this.props.getPhotoUrl}
                />
              </div>{" "}
              &nbsp;&nbsp;
              <div className="descBox">
                <p>{data.empname}</p>
                <div>
                  Applied On{" "}
                  {convertTimezoneDayMonth(data.raisedon.date, data.timezone)}
                </div>
                <div>
                {this.getUTCFromTimezone(data.timezone) !==
                  this.getTimezoneString() && (
                  <>
                   
                    <div style={{ fontStyle: "italic",   fontSize: "10px" }}>
                      {data.timezone}
                    </div>
                  </>
                )}
                </div>
               
              </div>
              {data.allowdelete == 1 ? (
                <IconButton style={{ position: "relative", top: "-10px" }}>
                  <DeleteIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          </td>
          <td>
            <span style={{ alignContent: "center", fontSize: "14px" }}>
              {data.leavetype}
            </span>
          </td>
          <td>
            <div
              className="Table_from_date"
              style={{ display:"flex", alignItems:"center", fontSize: "14px" }}
            >
              <div >
                <ArrowUpwardIcon />
              </div>
              <div>
                <div>
                {convertTimezoneDayMonth(data.from.date, data.timezone)}
                </div>
                {this.getUTCFromTimezone(data.timezone) !==
                this.getTimezoneString() && (
                <>
                  <div style={{  fontStyle: "italic",   fontSize: "10px" }}>
                    {data.timezone}
                  </div>
                </>
              )}
               <div>
                </div> 
              </div>

              
            </div>
            <div
              className="Table_to_date"
              style={{ display:"flex", alignItems:"center", fontSize: "14px" }}
            >
              <div >
                <ArrowDownwardIcon  />
              </div>
              <div> 
                <div>
                {convertTimezoneDayMonth(data.to.date, data.timezone)}
                </div>
              
<div>
{this.getUTCFromTimezone(data.timezone) !==
                this.getTimezoneString() && (
                  <>
                  <div style={{ fontStyle: "italic",   fontSize: "10px" }}>
                  {data.timezone}
                </div>
                  </>
                
              )}
</div>
             
              </div>
            </div>
          </td>
          <td>
            <span style={{ alignContent: "center", fontSize: "14px" }}>
              {data.reason}
            </span>
          </td>
          <td>

            {data.substituteempid !==undefined && data.substituteempid !== null && data.substituteempname !== "" && data.substituteempid !==-1 &&
            
            <div
            className="LeaveUserDescription"
            style={{ alignContent: "center", fontSize: "14px" }}
          >
            
            <div className="image">
            <GetImage
              key={data.empid}
                top={true}
                width={"32px"}
                height={"32px"}
                imgID={data.substituteempid}
                getPhotoUrl={this.props.getPhotoUrl}
              />
            </div>
            &nbsp; &nbsp;
            <div className="descBox2">
              <p>{data.substituteempname}</p>
            </div> 
          </div>
            }
           
          </td>
          <td>
            <span
              style={{
                alignContent: "center",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {data.totaldays}
            </span>
          </td>
        </>
      );
    } else if (approvaltype == "3") {
      return (
        <>
          <td style={{ position: "relative" }}>
            {this.getTAgIDActionDescription(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
          </td>
          <td>
            <div className="tagid_userdescription">
              <GetImage
               key={data.empid}
                top={true}
                width={"50px"}
                height={"50px"}
                imgID={data.empid}
                getPhotoUrl={this.props.getPhotoUrl}
              />
              <span>{data.firstname + " " + data.lastname}</span>
            </div>
          </td>
          <td>
            <div className="tagid_userbirthday">
              <img src={BirthdayIcon} alt="" />
              <span>{this.getDOB(data.dob)}</span>
            </div>
          </td>
        </>
      );
    } else if (approvaltype == "2") {
      return (
        <>
          <td style={{ position: "relative" }}>
            {this.getSubordinateDescription(data)}
          </td>
          <td>
            <div className="tagid_userdescription">
              <GetImage
               key={data.empid}
                top={true}
                width={"50px"}
                height={"50px"}
                imgID={data.empid}
                getPhotoUrl={this.props.getPhotoUrl}
              />
              <span>{data.firstname + " " + data.lastname}</span>
            </div>
          </td>
          <td>
            {data.phoneno != null &&
            data.phoneno != "-1" &&
            data.phoneno != "" ? (
              <div className="tagid_userbirthday">
                <img src={PhoneIcon} alt="" />
                <span>+91 {data.phoneno}</span>
              </div>
            ) : (
              "--"
            )}
          </td>
          <td>
            <div className="tagid_userbirthday">
              <img src={BirthdayIcon} alt="" />
              <span>{this.getDOB(data.dob)}</span>
            </div>
          </td>
        </>
      );
    } else if (approvaltype == "1") {
      return (
        <>
          <td style={{ position: "relative" }}>
            {this.getOvertimeDescription(data)}
          </td>
          <td>
            <div
              className="LeaveUserDescription"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ display: "flex" }}>
                <div
                  className="image"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <GetImage
                   key={data.empid}
                    top={true}
                    width={"32px"}
                    height={"32px"}
                    imgID={data.empid}
                    getPhotoUrl={this.props.getPhotoUrl}
                  />
                </div>
                <div className="descBox">
                  <p>{data.empname}</p>
                  <span>{this.getDOB(data.opentime)}</span>
                </div>
              </div>
              <div className="checkinImg" style={{ float: "right" }}>
                {data.checkintype == "1" ? (
                  <img
                    src={WFFIcon}
                    alt=""
                    style={{ width: "25px", height: "auto" }}
                  />
                ) : data.checkintype == "2" ? (
                  <img
                    src={HomeIcon}
                    alt=""
                    style={{ width: "25px", height: "auto" }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </td>
          <td>{this.getTime(data, "checkin")}</td>
          <td>{this.getTime(data, "checkout")}</td>
          <td>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                minHeight: "50px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {data.inofficehours != "-1"
                ? GetHrsTime(data.inofficehours, "hrs")
                : "-- Hrs"}
            </span>
          </td>
        </>
      );
    } else if (approvaltype == "5") {
      return (
        <>
          <td style={{ alignContent: "center" }}>
            {this.getGatePassDescription(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
          </td>
          <td>
            <div
              className="LeaveUserDescription"
              style={{ alignContent: "center" }}
            >
              <div className="image">
                <GetImage
                 key={data.empid}
                  top={true}
                  width={"32px"}
                  height={"32px"}
                  imgID={data.empid}
                  getPhotoUrl={this.props.getPhotoUrl}
                />
              </div>{" "}
              &nbsp;&nbsp;
              <div className="descBox">
                <p style={{ fontSize: "14px" }}>{data.empname}</p>
                <span style={{ fontSize: "14px" }}>
                  Applied On{" "}
                  {data.logtime !== null &&
                    convertTimezoneDayMonth(data.logtime.date, data.timezone)}
                </span>
                {/* {console.log(this.getUTCFromTimezone(data.timezone) !== this.getTimezoneString(),"whatt")} */}

                {this.getUTCFromTimezone(data.timezone) !==
                  this.getTimezoneString() && (
                  <>
                    <br />
                    <span style={{ fontStyle: "italic", fontSize: "10px" }}>
                      {data.timezone}
                    </span>
                  </>
                )}
              </div>
              {data.allowdelete == 1 ? (
                <IconButton style={{ position: "relative", top: "-10px" }}>
                  <DeleteIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          </td>
          {this.props.tableData[0].approvalstage == 1 && (
            <td>
              <span
                style={{
                  alignContent: "center",
                  fontSize: "14px",
                  color: "rgb(255, 0, 0)",
                }}
              >
                {data.starttime && (
                  <>
                    <span>
                      <ArrowUpwardIcon />
                    </span>
                    {`${
                      data.starttime !== null &&
                      convertTimezoneDayMonth(data.starttime.date, data.timezone)
                    }`}
                    {this.getUTCFromTimezone(data.timezone) !==
                      this.getTimezoneString() && (
                      <>
                        <br />
                        <span style={{ fontStyle: "italic", fontSize: "12px" }}>
                          {data.timezone}
                        </span>
                      </>
                    )}
                  </>
                )}
              </span>
              <a
                href={`https://maps.google.com/?q=${data.startlocationname}&ll=${data.startlocationname}F&z=20`}
                target="_blank"
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                {data.startlocationname && (
                  <>
                    <img
                      src={LocationIcon}
                      alt=""
                      style={{ width: "25px", height: "auto" }}
                    />{" "}
                    {`${data.startlocationname ? data.startlocationname : ""}`}
                  </>
                )}
              </a>
            </td>
          )}
          {this.props.tableData[0].approvalstage == 1 ? (
            <td>
              <span
                style={{
                  alignContent: "center",
                  fontSize: "14px",
                  color: "#4caf50",
                }}
              >
                {data.endtime !== null && (
                  <>
                    <span>
                      <ArrowDownwardIcon />
                    </span>
                    {`${
                      data.endtime &&
                      convertTimezoneDayMonth(data.endtime.date, data.timezone)
                    }  `}
                    {this.getUTCFromTimezone(data.timezone) !==
                      this.getTimezoneString() && (
                      <>
                        <br />
                        <span style={{ fontStyle: "italic", fontSize: "12px" }}>
                          {data.timezone}
                        </span>{" "}
                      </>
                    )}
                  </>
                )}
              </span>
              <a
                href={`https://maps.google.com/?q=${data.endlocationname}&ll=${data.endlocationname}F&z=20`}
                target="_blank"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                {data.endlocationname && (
                  <>
                    <img
                      src={LocationIcon}
                      alt=""
                      style={{ width: "25px", height: "auto" }}
                    />{" "}
                    {`${data.endlocationname ? data.endlocationname : ""}`}
                  </>
                )}
              </a>
            </td>
          ) : (
            ""
          )}

          {this.props.tableData[0] &&
          this.props.tableData[0].approvalstage == 1 ? (
            <td>
              <span
                style={{
                  alignContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {this.convertMinutesToTime(data.tat) + " Hrs"}
              </span>
            </td>
          ) : (
            <td>
              <span
                style={{
                  alignContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {this.convertMinutesToTime(data.tat) + " Hrs"}
              </span>
            </td>
          )}

          {this.props.tableData[0] &&
          this.props.tableData[0].approvalstage == 1 ? (
            <td>
              <span
                style={{
                  alignContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {data.endtime && data.starttime
                  ? (() => {
                      try {
                        const startTimeString =
                          data.starttime.date.split(" ")[1];
                        const endTimeString = data.endtime.date.split(" ")[1];
                        const startTime = new Date(
                          `1970-01-01T${startTimeString}Z`
                        );
                        const endTime = new Date(
                          `1970-01-01T${endTimeString}Z`
                        );
                        const diff = endTime - startTime;
                        const hours = Math.floor(diff / (1000 * 60 * 60));
                        const minutes = Math.floor(
                          (diff % (1000 * 60 * 60)) / (1000 * 60)
                        );
                        return `${hours.toString().padStart(2, "0")}:${minutes
                          .toString()
                          .padStart(2, "0")} Hrs`;
                      } catch (error) {
                        return "";
                      }
                    })()
                  : ""}
              </span>
            </td>
          ) : (
            ""
          )}

          {data.approvalstage == 1 ? (
            <td>
              <span style={{ alignContent: "center", fontSize: "14px" }}>
                {data.reasontype}
              </span>
            </td>
          ) : (
            <td>
              <span style={{ alignContent: "center", fontSize: "14px" }}>
                {data.reasontype}
              </span>
            </td>
          )}
          {data.approvalstage == 1 ? (
            <td>
              <span style={{ alignContent: "center", fontSize: "14px" }}>
                {data.reason}
              </span>
            </td>
          ) : (
            <td>
              <span style={{ alignContent: "center", fontSize: "14px" }}>
                {data.reason}
              </span>
            </td>
          )}
        </>
      );
    } else if (approvaltype == "6") {
      return (
        <>
          <td style={{ position: "relative" }}>
            {this.getExpenseDescription(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
          </td>

          <td>
            <div className="LeaveUserDescription">
              <div className="image">
                <GetImage
                 key={data.empid}
                  top={true}
                  width={"32px"}
                  height={"32px"}
                  imgID={data.empid}
                  getPhotoUrl={this.props.getPhotoUrl}
                />
              </div>
              <div className="descBox">
                <p>{data.empname}</p>
                <span>Applied On {this.setFullDateString(data.expenseon).split(",")[1]}</span>
              </div>
              {data.allowdelete == 1 ? (
                <IconButton style={{ position: "relative", top: "-10px" }}>
                  <DeleteIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
                // paddingRight: "30px",
              }}
            >
              {data.description}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
            >
              {data.expenseon.date.split(" ")[0]}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
            >
              {data.expensetype}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
                fontWeight: "bold",
                // paddingRight: "40px",
              }}
            >{`${data.expenseamount} ${data.currency} `}</span>
          </td>
          {data.approvalstage == 1 ? (
            <td style={{alignContent:"center" ,  textAlign:"center"}}>
              <span
                style={{
                  // display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  // minHeight: "50px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  // paddingRight: "25px",
                }}
              >{`${data.approvedamount} ${data.currency}`}</span>
            </td>
          ) : (
            ""
          )}
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
            >
              {data.remarks}
            </span>
          </td>
          {data.approvalstage == 1 || data.approvalstage == 2 ? (
            <td style={{alignContent:"center" , textAlign:"center"}}>
              <span
                style={{
                  // display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  // minHeight: "50px",
                  fontSize: "14px",
                  // paddingRight: "45px",
                }}
              >
                {data.approverremarks}
              </span>
            </td>
          ) : (
            ""
          )}

          {data.attachmentid && (
            <td>
              <IconButton
                style={{ position: "relative", left: "20px" }}
                onClick={() =>
                  this.viewAttachment(data.attachmentid, data.approvalempname)
                }
              >
                <AttachFileIcon />
              </IconButton>
            </td>
          )}
        </>
      );
    } else if (approvaltype == "7") {
      return (
        <>
          <td style={{ position: "relative" }}>
            {this.getFieldpassDescription(
              data,
              approvaltype,
              this.props.RequestCategory
            )}
          </td>
          <td>
            <div className="LeaveUserDescription">
              <div className="image">
                <GetImage
                 key={data.empid}
                  top={true}
                  width={"32px"}
                  height={"32px"}
                  imgID={data.empid}
                  getPhotoUrl={this.props.getPhotoUrl}
                />
              </div>
              <div className="descBox">
                <p>{data.empname}</p>
                <span>Applied On {this.setFullDateString(data.logtime)}</span>
              </div>
              {data.allowdelete == 1 ? (
                <IconButton style={{ position: "relative", top: "-10px" }}>
                  <DeleteIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
              className="raiseData"
            >
              {this.setFullDateString(data.raisedon).split(",")[1]}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
                fontWeight: "bold",
              }}
              className="passtype"
            >
              {data.passtype}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
              className="stage"
            >
              {data.stage == 1 ? "Used" : "Un-Used"}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
              className="reason"
            >
              {data.reason}
            </span>
          </td>
          <td style={{alignContent:"center" , textAlign:"center"}}>
            <span
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                // minHeight: "50px",
                fontSize: "14px",
              }}
            >
              {data.remarks}
            </span>
          </td>
          {data.approvalstage == 1 || data.approvalstage == 2 ? (
            <td style={{alignContent:"center" , textAlign:"center"}}>
              <span
                style={{
                  // display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  // minHeight: "50px",
                  fontSize: "14px",
                }}
              >
                {data.approverremarks}
              </span>
            </td>
          ) : (
            ""
          )}
        </>
      );
    }
  }
  handleIconClick = (attachmentid) => {
    // console.log(attachmentid);
    // Update the state with the clicked attachmentid and open the modal
    this.setState({
      attachmentid,
      isViewModalOpen: true,
      isQueryHitComplete: true,
    });
  };

  render() {
    return (
      <>
        {this.props.tableData.length > 0 ? (
          <Table responsive id="myReportTable" className=" text-left">
            <thead>
              <tr
                style={{
                  background: "var(--Primary)",
                  border: "none",
                  color: "white",
                  position: "sticky",
                  top: "0px",
                  zIndex: "1",
                  fontSize:"16px"
                }}
              >
                {this.getHeader(this.props)}
              </tr>
            </thead>
            <tbody>
              {this.props.tableData.map((s, index) => {
                return (
                  <>
                    <VisibilitySensor
                      key={index}
                      onChange={(isVisible) => {
                        if (
                          index == this.props.tableData.length - 1 &&
                          isVisible
                        ) {
                          if (!this.props.isLastList) {
                            this.props.LoadMore(s.recid);
                          }
                        }
                      }}
                    >
                      <tr key={index} style={{ textAlign: "left" }}>
                        {this.setRowsFromHeaders(s, this.props.approvaltype)}
                      </tr>
                    </VisibilitySensor>
                    {index == Object.keys(this.props.tableData).length - 1 ? (
                      !this.props.isLastList ? (
                        <tr>
                          <td colspan={7} style={{ textAlign: "center" }}>
                             <Loader/>
                          </td>
                        </tr>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div className="TemporaryTableDiv">
            <h5 style={{ color: "orange" }}>No Records!</h5>
          </div>
        )}
        {/* Loading modal start */}
        <Modal
          className="LoadingModal"
          size="sm"
          centered
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          show={this.state.isModalLoading}
          onHide={() => this.setState({ isModalLoading: false })}
          keyboard="static"
          backdrop={false}
          id="modalid"
        >
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
               <Loader/>
            </div>
          </Modal.Body>
        </Modal>
        {/* Loading modal end */}

        <Modal
        centered
          show={this.state.showModal}
          onHide={this.handleModalClose}
          style={{ padding: "0px" }}
            id="modalid"
        >
          {/* <Modal.Header closeButton  style={{paddingTop:"5px",paddingBottom:"5px"}}>
                        
                        <h6 style={{ color: '#4ecfec' }}>REMARKS</h6>
                    </Modal.Header> */}
          <Modal.Body style={{ padding: "0px" }}>
          <div
              style={{
                marginBottom: "15px",
                marginTop: "10px",
                textAlign: "left",
              }}
            >
              Are you sure you want to{" "}
              {this.state.acceptrejectstate === "1" ? "accept" : "reject"} this
              request ?{" "}
            </div>
            {this.props.approvaltype === 6 &&
              this.state.acceptrejectstate == "1" && (
                <div className="form-group">
                  <label
                    htmlFor="approvedExpense"
                    style={{ display: "flex", color:"black", fontWeight:"600", justifyContent: "left" }}
                  >
                    Approved Amount<sup style={{ color: "red" }}>*</sup>
                  </label>
                  <input
                    style={{ backgroundColor: "#f2f2f2", border: "none" }}
                    type="text"
                    className="form-control"
                    id="approvedExpense"
                    placeholder="Enter approved amount"
                    value={this.state.approvedExpense}
                    onChange={(e) =>
                      this.setState({ approvedExpense: e.target.value })
                    }
                    required
                  />
                  <span style={{ color: "red" }}>
                    {this.state.errors["approvedExpense"]}
                  </span>
                </div>
              )}
            
            <div className="mt-1">
              <Inputbox
                wordboundation={{ limit: 100, id: "remarkInput" }}
                htmlFor={"REMARK"}
                label={"REMARKS"}
                type="text"
                labelStyle={{fontWeight:"500"}}
                placeholder={`Enter remarks`}
                value={this.state.remarks}
                onChange={(e) => this.setState({ remarks: e.target.value })}
                required={true}
              />
            </div>

          </Modal.Body>
          <Modal.Footer style={{ border: "none", padding: "0px" }}>
            <Button
              variant="secondary"
              onClick={this.handleModalClose}
              className="nobutton"
            >
              <b>No</b>
            </Button>
            <Button
              variant="primary"
              onClick={this.handleModalYes}
              className="yesbutton"
            >
              <b>Yes</b>
            </Button>
          </Modal.Footer>
        </Modal>
        <div>
          {this.state.isViewModalOpen ? (
            // <p>this is a modal</p>
            <modal
              show={this.state.isViewModalOpen}
              onHide={() => this.setState({ isViewModalOpen: false })}
              className="popup-container"
            >
              <div className="popup">
                <div className="expmodal-heading">
                  <h4 style={{ color: "#24b7fb", marginRight: "30px" }}>
                    Attachment{" "}
                  </h4>

                  <button
                    className="expensebtnclose"
                    onClick={() => this.setState({ isViewModalOpen: false })}
                  >
                    <IoCloseOutline />
                  </button>
                </div>
                <div>
                  {this.state.isQueryHitComplete && (
                    <Attachment
                      attID={this.state.attachmentid}
                      userid={this.props.userid}
                      isFileALlowDownload={this.state.isAllowDownload}
                      isViewModalOpen={() => !this.state.isViewModalOpen}
                      isViewModalClose={() =>
                        this.setState({ isViewModalOpen: false })
                      }
                      disablewatermark={this.state.watermarkArr}
                      approvalempname={this.state.approvalempname}
                    />
                  )}
                  {/* {console.log(this.state.isViewModalOpen)} */}
                </div>
              </div>
            </modal>
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}
